import { render, staticRenderFns } from "./Terminate.vue?vue&type=template&id=f5f575e0"
import script from "./Terminate.vue?vue&type=script&lang=js"
export * from "./Terminate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports